import { FunctionComponent } from "react";
import {
  CafeCard,
  CafeCardProps,
  useScreenSizeContext,
} from "@bluebottlecoffee/design-system/components";
import { Cafe as CafeType } from "@bluebottlecoffee/design-system/components/lib/types";
import {
  CafeHoursCopy,
  toCafeCardProps,
} from "../../lib/transformers/cafe-card";
import { AlgoliaCafe } from "../../lib/algolia/types";
import { CafeHoursModel, useCafeHours } from "../../lib/integrations/orion";
import { Cafe as CafeSchema } from "../../lib/sanity-schema";

type CafeSearchResultProps = (
  | {
      cafe: CafeSchema;
      algoliaHit?: never;
    }
  | {
      cafe?: never;
      algoliaHit: AlgoliaCafe;
    }
) & {
  cafeCardProps: Omit<CafeCardProps, "cafe">;
  cafeHoursCopy: CafeHoursCopy;
  isModule: boolean;
  lang: string;
  region: string;
  isCafeSearch?: boolean;
};

export const CafeSearchResult: FunctionComponent<CafeSearchResultProps> = ({
  algoliaHit,
  cafe,
  cafeCardProps,
  cafeHoursCopy: copy,
  isModule,
  lang,
  region,
  isCafeSearch,
}) => {
  const { isDesktop, isLgTablet } = useScreenSizeContext();
  const isLgViewport: boolean = isDesktop() || isLgTablet();

  const data = cafe ?? algoliaHit;
  const hours: CafeHoursModel[] = useCafeHours({
    branchNumber: data.branchNumber,
  });
  const transformedCafe: CafeType = toCafeCardProps({
    copy,
    data,
    lang,
    region,
    hours,
    isCafeSearch,
  });

  return (
    <CafeCard
      {...cafeCardProps}
      cafe={transformedCafe}
      layout={isLgViewport && !isModule ? "landscape" : "portrait"}
    />
  );
};

CafeSearchResult.defaultProps = {
  isCafeSearch: false,
};
